import { ToastContainer, toast } from 'react-toastify';
import * as Sentry from "@sentry/react";

export function HikoToastContainer() {

  return (
      <ToastContainer />
  );
}

/**
 * 
 * @param {string} title    - brief message suitable for a user
 * @param {string} message  - detailed message intended for dev / support team
 * @param {string} severity - ('info'|'warning'|'error'|'success') default is 'error'
 * @param {*} toastOptions  - e.g. { type: ..., position: ..., autoClose: ...} See react-toast docs.
 */
export function hikoAlert(title, message, severity = 'error', callerToastOptions = {}, logToConsole = true) {

  if (logToConsole) {
    if (severity === 'error') {
      console.error(title, message)
    } else {
      console.log(title, message)
    }
  }

  const appendMessage = true; // ToDo: Do this dependent on dev/production
  let toastType;
  switch (severity) {
    case 'success':
      toastType = 'success';
      break;
    case 'info':
      toastType = 'info';
      break;
    case 'warning':
      toastType = 'warning';
      break;
    case 'error':
    default:
      toastType = 'error';
      break;
  }

  const hikoToastOverrides = {
    type: toastType,
  };

  let mergedOptions = Object.assign({}, callerToastOptions, hikoToastOverrides);

  let toastComponent = <h3>{title}</h3>;
  if (appendMessage && message) {
    toastComponent =
      <>
        {toastComponent}
        <h4 style={{overflowWrap: 'anywhere'}}>{message}</h4>
      </>;
  }
  hikoToast(toastComponent, mergedOptions);
}

/**
 * 
 * @param {string} title 
 * @param {Error} e 
 */
export function hikoException(title, e) {
  console.error(title, e);
  hikoAlert(title, e.message, 'error', {}, false);
  //
  // All hikoExceptions get sent to Sentry.
  //
  Sentry.captureException(e);
}

/**
 * 
 * @param {string | component} message - e.g. "Don't do that" or <h3>Well done!</h3>
 * @param {object} callerToastOptions 
 */
export function hikoToast(message, callerToastOptions = {}) {
  const basicHikoToastOptions = {
    hideProgressBar: true,
    autoClose: 7500, // 7.5 seconds
  };

  let mergedOptions = Object.assign({}, callerToastOptions, basicHikoToastOptions);

  toast(message, mergedOptions);
}

